import { canonicalJson, sha256Hex } from '../reportGeneration/reportContractHash';
import type { EconomicCoefficientBand } from '../../types/economicContribution';

export function hashEconomicModelInput(value: unknown): string {
  return sha256Hex(canonicalJson(value));
}

export function finitePositive(value: number | undefined | null): value is number {
  return typeof value === 'number' && Number.isFinite(value) && value > 0;
}

export function finiteNonNegative(value: number | undefined | null): value is number {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0;
}

export function roundEconomic(value: number, digits = 2): number {
  const scale = 10 ** digits;
  return Math.round((value + Number.EPSILON) * scale) / scale;
}

export function bandForMw(
  bands: readonly EconomicCoefficientBand[],
  mw: number,
): EconomicCoefficientBand | null {
  return bands.find((band) => (
    mw >= band.minMwInclusive
      && (band.maxMwExclusive == null || mw < band.maxMwExclusive)
  )) ?? null;
}

export function sortedRange(low: number, high: number): { low: number; high: number } {
  return low <= high ? { low, high } : { low: high, high: low };
}
